/* eslint-disable default-case */
// utils
import { filter } from "lodash";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  orderBy as firebaseOrderBy,
  updateDoc,
} from "firebase/firestore";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Button,
  Backdrop,
  Modal,
  Fade,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { db, auth, storage } from "../Firebase/firebase";
// material
// components
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import {
  UserListHead,
  UserMoreMenu2,
  UserMoreMenu3,
} from "../components/_dashboard/user";
import { useParams } from "react-router-dom";
import { fCurrency } from "../utils/formatNumber";
import { Box, width } from "@mui/system";
import { DatePicker } from "react-responsive-datepicker";
import "react-responsive-datepicker/dist/index.css";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  {
    id: "City",
    label: "City",
    alignRight: false,
  },
  {
    id: "heading",
    label: "Heading",
    alignRight: false,
  },
  {
    id: "details",
    label: "Details",
    alignRight: false,
  },
  { id: "" },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function OrderDetails() {
  const [currentUser, setCurrentUser] = useState();
  const [usersList, setUsersList] = useState([]);
  const navigate = useNavigate();
  const { uid, orderId } = useParams();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        navigate("/login");
      }
    });
  }, [navigate]);

  useEffect(() => {
    const q = query(collection(db, `users/${uid}/orders/${orderId}/details`));
    const unSubscribe = onSnapshot(q, (snapshot) => {
      const dbUsers = [];
      snapshot.forEach((doc) => {
        dbUsers.push({
          transactionId: doc.id,
          ...doc.data(),
        });
      });
      setUsersList(dbUsers);
    });

    return unSubscribe;
  }, [uid]);

  const users = usersList.map((user) => ({
    id: uid,
    orderId: orderId,
    stageId: user.transactionId,
    City: user.City,
    date: user.date,
    details: user.details,
    heading: user.heading,
    time: user.time,
  }));

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const filteredUsers = applySortFilter(
    users,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  // Modal
  const [openAddUserModel, setOpenAddUserModel] = useState(false);
  const [openAddImageModel, setOpenAddImageModel] = useState(false);
  const [addUserAlert, setaddUserAlert] = useState("");
  const [updateButton, setUpdateButton] = useState("Add transaction");
  const [city, setCity] = useState("");
  const [details, setDetails] = useState("");
  const [heading, setHeading] = useState("");
  const [status, setStatus] = useState("");
  const [day, setDay] = useState();
  const [month, setmonth] = useState();
  const [year, setYear] = useState();

  const handleOpenAddUserModel = () => setOpenAddUserModel(true);
  const handleOpenAddImageModel = () => setOpenAddImageModel(true);

  const handleCloseAddUserModel = () => {
    setOpenAddUserModel(false);
    setaddUserAlert("");
  };

  const handleCloseAddImageModel = () => {
    setOpenAddImageModel(false);
    setaddUserAlert("");
  };

  // Modal Styles
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    overflow: "scroll",
    height: "auto",
    display: "block",
    bgcolor: "background.paper",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 400,
    border: "none",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  const handleCreate = () => {
    setUpdateButton("Loading...");
    var d = new Date();
    let hour = d.getHours();
    let min = d.getMinutes();
    let sec = d.getSeconds();

    var mydate = new Date(`${year}-${month}-${day}T${hour}:${min}:${sec}`);
    const fireTmeStamp = Timestamp.fromDate(mydate);

    const dateFormatter = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(mydate);

    addDoc(collection(db, `users/${uid}/orders/${orderId}/details`), {
      City: city,
      date: dateFormatter,
      details: details,
      heading: heading,
      time: `${hour}:${min}:${sec}`,
      updatedAt: fireTmeStamp,
    })
      .then(() => {
        setUpdateButton("Add transaction");
        alert("Order created");
      })
      .catch((err) => {
        console.log(err);
        setUpdateButton("Add transaction");
        alert("Transaction created");
      });
  };

  //   Upload Image
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const storageRef = ref(storage, `images/${uid}/${file.name}`);

      // 'file' comes from the Blob or File API
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;

            // ...

            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            updateDoc(doc(db, `users/${uid}/orders/${orderId}`), {
              imageLink: downloadURL,
            }).then(() => {
              alert("Image Uploaded");
            });
          });
        }
      );
    }
  };

  return (
    <div>
      <Page title="User | Dashboard">
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Order Stages
            </Typography>
          </Stack>

          <div style={{ margin: "30px 0" }}>
            <Button variant="contained" onClick={handleOpenAddUserModel}>
              Add Stage
            </Button>
            <Button
              style={{ margin: "0 10px" }}
              variant="contained"
              onClick={handleOpenAddImageModel}
            >
              Add Image
            </Button>
          </div>

          <div className="">
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={openAddImageModel}
              onClose={handleCloseAddImageModel}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openAddImageModel}>
                <Box component="form" sx={style} noValidate autoComplete="off">
                  <div style={{ margin: "0 0 5px 0", textAlign: "center" }}>
                    <p
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "5px",
                      }}
                    >
                      Add Image
                    </p>

                    <div style={{ marginBottom: 20 }}>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                        />
                        <div
                          style={{
                            padding: "10px 15px",
                            border: "1px dashed",
                            borderRadius: "4px",
                          }}
                        >
                          Upload image
                        </div>
                      </label>
                    </div>
                  </div>
                </Box>
              </Fade>
            </Modal>
          </div>

          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={openAddUserModel}
              onClose={handleCloseAddUserModel}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openAddUserModel}>
                <Box component="form" sx={style} noValidate autoComplete="off">
                  <div style={{ margin: "0 0 5px 0", textAlign: "center" }}>
                    <p
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "5px",
                      }}
                    >
                      Add a new stage
                    </p>

                    <TextField
                      label="City"
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      onChange={(e) => setCity(e.target.value)}
                    />

                    <FormControl
                      style={{
                        margin: "0 0 10px 0",
                        width: "30%",
                        marginRight: "5px",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">Day</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Day"
                        onChange={(e) => setDay(e.target.value)}
                      >
                        <MenuItem value="01">01</MenuItem>
                        <MenuItem value="02">02</MenuItem>
                        <MenuItem value="03">03</MenuItem>
                        <MenuItem value="04">04</MenuItem>
                        <MenuItem value="05">05</MenuItem>
                        <MenuItem value="06">06</MenuItem>
                        <MenuItem value="07">07</MenuItem>
                        <MenuItem value="08">08</MenuItem>
                        <MenuItem value="09">09</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="11">11</MenuItem>
                        <MenuItem value="12">12</MenuItem>
                        <MenuItem value="13">13</MenuItem>
                        <MenuItem value="14">14</MenuItem>
                        <MenuItem value="15">15</MenuItem>
                        <MenuItem value="16">16</MenuItem>
                        <MenuItem value="17">17</MenuItem>
                        <MenuItem value="18">18</MenuItem>
                        <MenuItem value="19">19</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="21">21</MenuItem>
                        <MenuItem value="22">22</MenuItem>
                        <MenuItem value="23">23</MenuItem>
                        <MenuItem value="24">24</MenuItem>
                        <MenuItem value="25">25</MenuItem>
                        <MenuItem value="26">26</MenuItem>
                        <MenuItem value="27">27</MenuItem>
                        <MenuItem value="28">28</MenuItem>
                        <MenuItem value="29">29</MenuItem>
                        <MenuItem value="30">30</MenuItem>
                        <MenuItem value="31">31</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        margin: "0 0 10px 0",
                        width: "30%",
                        marginRight: "5px",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Month
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Month"
                        onChange={(e) => setmonth(e.target.value)}
                      >
                        <MenuItem value="01">Jan</MenuItem>
                        <MenuItem value="02">Feb</MenuItem>
                        <MenuItem value="03">Mar</MenuItem>
                        <MenuItem value="04">Apr</MenuItem>
                        <MenuItem value="05">May</MenuItem>
                        <MenuItem value="06">Jun</MenuItem>
                        <MenuItem value="07">Jul</MenuItem>
                        <MenuItem value="08">Aug</MenuItem>
                        <MenuItem value="09">Sep</MenuItem>
                        <MenuItem value="10">Oct</MenuItem>
                        <MenuItem value="11">Nov</MenuItem>
                        <MenuItem value="12">Dec</MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      label="Year"
                      style={{
                        margin: "0 0 10px 0",
                        width: "30%",
                        // marginRight: "5px",
                      }}
                      onChange={(e) => setYear(e.target.value)}
                      type="number"
                    />

                    <TextField
                      label="Details"
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      onChange={(e) => setDetails(e.target.value)}
                    />

                    <TextField
                      label="Heading"
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      onChange={(e) => setHeading(e.target.value)}
                    />

                    <Button
                      variant="contained"
                      onClick={handleCreate}
                      disabled={
                        updateButton === "Add transaction" ? false : true
                      }
                      style={{ width: "100%" }}
                    >
                      {updateButton}
                    </Button>
                  </div>
                </Box>
              </Fade>
            </Modal>
          </div>

          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={users.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const { id, orderId, stageId, City, details, heading } =
                          row;

                        return (
                          <TableRow hover key={stageId} tabIndex={-1}>
                            <TableCell align="left">{City}</TableCell>
                            <TableCell align="left">{heading}</TableCell>
                            <TableCell align="left">{details}</TableCell>
                            <TableCell align="right">
                              <UserMoreMenu3
                                uid={id}
                                orderId={orderId}
                                stageId={stageId}
                                City={City}
                                details={details}
                                heading={heading}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={users.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      </Page>
    </div>
  );
}
